const domaine = 'COORDONNEES_BANCAIRES'

export const AJOUTER_FORMULAIRE_COORDONNEES_BANCAIRES = `${domaine}/AJOUTER_FORMULAIRE_COORDONNEES_BANCAIRES`
